import moment from "moment";
import _ from "underscore";

import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";

import {
	CLOSE_ADD_SEARCH_TO_GRAPH_MODAL,
	CLOSE_CONTENT_HEADER_TOOLTIP,
	LOADING_MEDIA_ENTITIES,
	LOADING_MEDIA_LINE,
	OPEN_ADD_SEARCH_TO_GRAPH_MODAL,
	OPEN_CONTENT_HEADER_TOOLTIP,
	MEDIA_FORMAT_CONTENT_FILTERED_BY_DATE,
	MEDIA_GRAPH_SPINNER_ON,
	MEDIA_SET_AGGREGATION_LEVEL,
	REMOVE_MEDIA_TIMESERIES,
	REMOVE_SEARCH_FROM_GRAPH,
	RESET_MEDIA_ARTICLES_CURSOR_POS,
	SET_MEDIA_INDICATOR,
	SET_MEDIA_SORT_DETAILS,
	SET_MEDIA_TRANSLATE_TOGGLE,
	SELECT_SEARCH_TO_ADD_TO_GRAPH,
	UPDATE_OUTLET_FILTERS,
	SET_MEDIA_ARTICLES_EXPANDED,
	SET_MEDIA_ARTICLES_CURSOR_POS,
	SET_MEDIA_COMPARABLE_SEARCHES,
	SET_MEDIA_ENTITIES_EXPANDED,
	SET_MEDIA_MAP_EXPANDED,
	SET_MEDIA_TIMESERIES_EXPANDED,
	SET_MEDIA_TIMESERIES_SHRUNK,
	MEDIA_SET_PENDING_MAP_CHANGES,
	MEDIA_CLEAR_PENDING_MAP_CHANGES,
	MEDIA_SET_PENDING_TIMESERIES_CHANGES,
	MEDIA_CLEAR_PENDING_TIMESERIES_CHANGES,
	MEDIA_SET_PENDING_ENTITY_CHANGES,
	MEDIA_CLEAR_PENDING_ENTITY_CHANGES,
	MEDIA_TOGGLE_SHOW_MAP,
	MEDIA_TOGGLE_SHOW_TIMELINE,
	MEDIA_TOGGLE_SHOW_ENTITIES,
} from "actions/constants.js";
import {
	updateDynamicFilters,
} from "actions/searchActions.js";
import {
	SEARCH_UPDATE_FILTERS
} from "actions/constants/searchActionTypes.js";
import {
	fetchMediaData,
	fetchSocialMediaData,
	fetchMediaArticles,
	fetchMediaTimeseries,
	fetchMediaTimeseriesToCompare,
	fetchEntityFilters,
	fetchSourceCountryFilters,
} from "actions/fetch";
import { 
	addOrRemoveDynamicHierarchyFilter,
	convertCountryDataToEntityFilter,
	findFilterByFieldName,
} from "lib/helpers/filterHelpers.js";
import { setActiveChatConfig } from 'actions/chatActions';
import { DATASET_ID_MEDIA, DATASET_ID_SOCIAL_MEDIA } from 'layout/DataExplorer/DataExplorerConstants.js';

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

const stateId = SEARCH_STATE_IDS.MEDIA;

const CONTENT_PAGE_LENGTH = 50;

export function updateMediaEntities() {
	return (dispatch, getState) => {
		const {
			activeSearchObj,
			currentFiltersList,
			currentEntityType,
		} = getState().search[stateId];

		const { entitiesExpanded, showEntities } = getState().media;
		if (entitiesExpanded && showEntities) {
			dispatch({type: MEDIA_CLEAR_PENDING_ENTITY_CHANGES});
			const noActiveSearch = _.isEmpty(activeSearchObj) || 
				activeSearchObj.query.trim() === "";
			const noFilters = !Array.isArray(currentFiltersList) || currentFiltersList.length === 0;	
			if (!noActiveSearch || !noFilters) {
				dispatch(fetchEntityFilters(stateId, currentEntityType));
			}
		}
		else {
			dispatch({type: MEDIA_SET_PENDING_ENTITY_CHANGES});
		}
	}
};

export function updateMediaTimeseries() {
	return (dispatch, getState) => {
		const { activeSearchObj } = getState().search[stateId];
		const { timeSeriesExpanded, showTimeseries } = getState().media;
		if (timeSeriesExpanded && showTimeseries) {
			dispatch({type: MEDIA_CLEAR_PENDING_TIMESERIES_CHANGES});
			dispatch({ type: LOADING_MEDIA_LINE, payload: { lineLoading: true } });
			dispatch(fetchMediaTimeseries({	searchObj: activeSearchObj }));
		}
		else {
			dispatch({type: MEDIA_SET_PENDING_TIMESERIES_CHANGES});
		}
	}
};

export function initMediaMap() {
	return (dispatch) => {
		dispatch(fetchSourceCountryFilters(true));
	}
};

export function updateMediaMap() {
	return (dispatch, getState) => {
		const { mapExpanded, showMap } = getState().media;
		if (mapExpanded && showMap) {
			dispatch({type: MEDIA_CLEAR_PENDING_MAP_CHANGES});
			dispatch(fetchSourceCountryFilters(false));
		}
		else {
			dispatch({type: MEDIA_SET_PENDING_MAP_CHANGES});
		}
	}
};

export function toggleShowMap() {
	return (dispatch) => {
		dispatch({type: MEDIA_TOGGLE_SHOW_MAP});
	}
};

export function toggleShowTimeseries() {
	return (dispatch) => {
		dispatch({type: MEDIA_TOGGLE_SHOW_TIMELINE});
	}
};

export function toggleShowEntities() {
	return (dispatch) => {
		dispatch({type: MEDIA_TOGGLE_SHOW_ENTITIES});
	}
};

export function updateMediaResults() {
	return (dispatch, getState) => {
		const {
			activeSearchObj,
			currentFiltersList
		} = getState().search[stateId];
		const noActiveSearch = _.isEmpty(activeSearchObj) || activeSearchObj.query.trim() === "";
		const noFilters = !Array.isArray(currentFiltersList) || currentFiltersList.length === 0;
		if (!noActiveSearch || !noFilters) {
			// Fetch Map Data
			dispatch(updateMediaMap());
			// Fetch Timeseries graph data
			dispatch(updateMediaTimeseries());
			// Fetch Content/Articles
			dispatch(updateMediaArticles());
			// Fetch Entities
			dispatch(updateMediaEntities());
		}
		// Update Dynamic Filters
		dispatch(updateDynamicFilters(stateId));
	}
};

export function setMediaComparableSearches(searchObj) {
	return (dispatch, getState) => {
		const { searches } = getState().search[stateId];
		dispatch({ type: SET_MEDIA_COMPARABLE_SEARCHES, searches, searchObj });
	}
};

// Fetch the new data here
export function mediaZoomInit(zoom, roundUp=false) {
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			showTranslate,
			// HIDING_FOR_NOW
			// showGarbage,
			// showHidden,
			// showInternational,
		} = getState().media;
		const {
			activeSearchObj,
			currentZoom,
			currentEntityType,
		} = getState().search[stateId];
		dispatch({
			type: SET_MEDIA_INDICATOR,
			payload: { contentFilteredByDate: false },
		});

		const { begin } = zoom;
		const end = zoom.end + (roundUp ? (24 * 60 * 60 * 1000) : 0)

		// Ignore zoom init if current zoom will not change
		if ((currentZoom.begin === begin) && (currentZoom.end === end)) {
			return;
		}

		// Clear filter by date indicator
		dispatch({type: SET_MEDIA_INDICATOR, payload: { contentFilteredByDate: false }});

		// Update Map Data to reflect new time range
		dispatch(updateMediaMap());

		// Update articles to reflect new time range
		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(
			fetchMediaArticles({
				query: activeSearchObj && activeSearchObj.query,
				begin,
				end,
				searchObj: activeSearchObj,
				// HIDING_FOR_NOW
				// showGarbage,
				// showHidden,
				// showInternational,
				showTranslate,
				sortBy: articlesSortType,
				ascending: articlesSortAscending,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: 0,
			})
		);

		// Update entities to reflect new time range
		dispatch(updateMediaEntities());

		// Update dynamic filters to reflect new time range
		dispatch(updateDynamicFilters(stateId));

	};
};

export function mediaClearIndicator() {
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			showTranslate,
			// HIDING_FOR_NOW
			// showGarbage,
			// showHidden,
			// showInternational,
		} = getState().media;
		const {
			activeSearchObj,
			currentZoom,
			currentEntityType,
		} = getState().search[stateId];

		// Update Map Data
		dispatch(updateMediaMap());

		// Update Articles
		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(
			fetchMediaArticles({
				ascending: articlesSortAscending,
				begin: currentZoom.begin,
				end: currentZoom.end,
				query: activeSearchObj && activeSearchObj.query,
				searchObj: activeSearchObj,
				showTranslate,
				sortBy: articlesSortType,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: 0,
				// HIDING_FOR_NOW
				// showGarbage,
				// showHidden,
				// showInternational,
			})
		);

		// Update entities
		dispatch(updateMediaEntities());

		// Update dynamic filters
		dispatch(updateDynamicFilters(stateId));

		// Set media indicator
		dispatch({
			type: SET_MEDIA_INDICATOR,
			payload: { contentFilteredByDate: false },
		});
	};
};

export function mediaFilterContentByDate(unit, left) {
	return (dispatch, getState) => {
		if (unit) {
			const {
				aggregationLevel,
				articlesSortType,
				articlesSortAscending,
				showTranslate,
			} = getState().media;
			const {
				activeSearchObj,
				currentEntityType,
			} = getState().search[stateId];

			const adjustedBegin = adjustStartDateForAggregation({ 
				startDate: Number(unit), 
				aggregationLevel,
			});
			const adjustedEnd = Number(unit) + (24 * 60 * 60 * 1000) - 1;
			const contentFilteredByDate = unit
			? {
					begin: adjustedBegin,
					end: adjustedEnd,
					indicatorWidth: 3,
					indicatorOffset: left,
				}
			: false;

			dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
			dispatch({ type: SET_MEDIA_INDICATOR, payload: { contentFilteredByDate }});

			// Update Map Data 
			dispatch(updateMediaMap());

			// Update Articles
			dispatch(
				fetchMediaArticles({
					ascending: articlesSortAscending,
					begin: adjustedBegin,
					end: adjustedEnd,
					query: activeSearchObj && activeSearchObj.query,
					searchObj: activeSearchObj,
					showTranslate,
					sortBy: articlesSortType,
					pageLength: CONTENT_PAGE_LENGTH,
					offset: 0,
				})
			);

			// Update entities
		dispatch(updateMediaEntities());

			// Update dynamic filters to reflect new time range
			dispatch(updateDynamicFilters(stateId));
		}
	};
};

export const updateMediaContentByHeader = (columnId, pageLength, offset)=> {
	const getDefaultSortAscending = () => {
		switch (columnId) {
			case "relevancy":
			case "date":
				return false;
			default:
				return true;
		}
	}
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			contentFilteredByDate,
			showTranslate,
			// HIDING_FOR_NOW
			// showGarbage,
			// showHidden,
			// showInternational,
		} = getState().media;
		const {
			activeSearchObj,
			currentZoom,
		} = getState().search[stateId];
		const ascending = !columnId ? articlesSortAscending 
			: (columnId === articlesSortType) 
				? !articlesSortAscending 
				: getDefaultSortAscending();
		const sortBy = columnId || articlesSortType;
		const beginDate = contentFilteredByDate ? contentFilteredByDate.begin : currentZoom.begin;
		const endDate = contentFilteredByDate
			? contentFilteredByDate.end
				? Number(contentFilteredByDate.end)
				: moment(Number(contentFilteredByDate.begin)).add(1, "days").format("x")
			: currentZoom.end;
		dispatch(
			fetchMediaArticles({
				ascending,
				begin: beginDate,
				end: endDate,
				query: activeSearchObj && activeSearchObj.query,
				searchObj: activeSearchObj,
				showTranslate,
				sortBy,
				pageLength,
				offset,
				// HIDING_FOR_NOW
				// showGarbage,
				// showHidden,
				// showInternational,
			})
		);
		dispatch({
			type: SET_MEDIA_SORT_DETAILS,
			payload: {
				articlesSortType: sortBy,
				articlesSortAscending: ascending,
			},
		});
	};
};

// FLAG_OUTLET_FILTERS
export const clickOutletFilter = (params) => {
	const { id } = params;
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			contentFilteredByDate,
			showTranslate,
			// HIDING_FOR_NOW
			// showGarbage,
			// showHidden,
			// showInternational,
		} = getState().media;
		const {
			activeSearchObj,
			currentEntityType,
			currentZoom,
		} = getState().search[stateId];
		const beginDate = contentFilteredByDate ? contentFilteredByDate.begin : currentZoom.begin;
		const endDate = contentFilteredByDate
			? contentFilteredByDate.end
				? Number(contentFilteredByDate.end)
				: moment(Number(contentFilteredByDate.begin)).add(1, "days").format("x")
			: currentZoom.end;
		// const updatedOutletFilters = addOrRemoveString(outletFilters, id);

		// Update Map Data 
		dispatch(updateMediaMap());

		// Update articles
		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(
			fetchMediaArticles({
				ascending: articlesSortAscending,
				begin: beginDate,
				end: endDate,
				query: activeSearchObj && activeSearchObj.query,
				searchObj: activeSearchObj,
				sortBy: articlesSortType,
				showTranslate,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: 0,
				// HIDING_FOR_NOW
				// showGarbage,
				// showHidden,
				// showInternational,
			})
		);

		// Update entities
		dispatch(updateMediaEntities());

		// Update timeline
		dispatch(updateMediaTimeseries());

		// Update dynamic filters
		dispatch(updateDynamicFilters(stateId));

		// Update media line loading
		dispatch({ type: LOADING_MEDIA_LINE, payload: { lineLoading: true } });
	};
};

export const setOutletFilter = (outlets) => {
	return (dispatch) => {
		dispatch({
			type: UPDATE_OUTLET_FILTERS,
			payload: { outletFilters: outlets },
		});
	};
};

export const resetOutletFilter = () => {
	//	console.log("resetOutletFilter");

	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			contentFilteredByDate,
			showTranslate,
			// HIDING_FOR_NOW
			// showGarbage,
			// showHidden,
			// showInternational,
		} = getState().media;
		const {
			activeSearchObj,
			currentEntityType,
			currentZoom,
		} = getState().search[stateId];

		const beginDate = contentFilteredByDate ? contentFilteredByDate.begin : currentZoom.begin;
		const endDate = contentFilteredByDate
			? contentFilteredByDate.end
				? Number(contentFilteredByDate.end)
				: moment(Number(contentFilteredByDate.begin)).add(1, "days").format("x")
			: currentZoom.end;

		dispatch({
			type: UPDATE_OUTLET_FILTERS,
			payload: { outletFilters: [] },
		});

		// Update Map Data 
		dispatch(updateMediaMap());

		// Update articles
		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(
			fetchMediaArticles({
				ascending: articlesSortAscending,
				begin: beginDate,
				end: endDate,
				query: activeSearchObj && activeSearchObj.query,
				outlets: [],
				searchObj: activeSearchObj,
				sortBy: articlesSortType,
				showTranslate,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: 0,
				// HIDING_FOR_NOW
				// showGarbage,
				// showHidden,
				// showInternational,
			})
		);
		dispatch({ type: LOADING_MEDIA_ENTITIES });

		// Update timeseries
		dispatch(updateMediaTimeseries());

		// Update dynamic filters
		dispatch(updateDynamicFilters(stateId));

		// Update entities
		dispatch(updateMediaEntities());
	};
};

export function updateMediaArticles() {
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			contentFilteredByDate,
			showTranslate,
		} = getState().media;
		const {
			activeSearchObj,
			timeStart,
			timeEnd,
		} = getState().search[stateId];

		const beginDate = contentFilteredByDate 
			? contentFilteredByDate.begin 
			: timeStart;
			// : currentZoom.begin;

		const endDate = contentFilteredByDate
			? contentFilteredByDate.end
				? Number(contentFilteredByDate.end)
				: moment(Number(contentFilteredByDate.begin)).add(1, "days").format("x")
			: timeEnd;
			// : currentZoom.end;

		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(fetchMediaArticles({
			begin: Number(beginDate),
			end: Number(endDate),
			query: activeSearchObj && activeSearchObj.query,
			searchObj: activeSearchObj,
			showTranslate,
			sortBy: articlesSortType,
			ascending: articlesSortAscending,
			setup: true,
			pageLength: CONTENT_PAGE_LENGTH,
			offset: 0,
		})); 
	};
};

// For updating contentFilteredByDate after window/graph resize
export const mediaFormatContentFilteredByDate = (graphSize, trimmedTrendDates) => {
	return {type: MEDIA_FORMAT_CONTENT_FILTERED_BY_DATE, graphSize, trimmedTrendDates};
};

export const mediaSetAggregationLevel = (params) => {
	const { level } = params;
	return (dispatch, getState) => {
		const {	aggregationLevel } = getState().media;
		if (aggregationLevel !== level) {
			dispatch({type: MEDIA_SET_AGGREGATION_LEVEL, level});
			dispatch({type: SET_MEDIA_INDICATOR, payload: { contentFilteredByDate: false }});
		}
	};
};

export function closeContentHeaderTooltip() {
	return {
		type: CLOSE_CONTENT_HEADER_TOOLTIP,
	};
};

export function openContentHeaderTooltip(params) {
	const { position, text } = params;
	return {
		type: OPEN_CONTENT_HEADER_TOOLTIP,
		contentHeaderTooltipElementPosition: position,
		contentHeaderTooltipText: text,
	};
};

// ---------- View article -----------
export function viewArticle(article, event) {
	// console.log("viewArticle", article);

	return (dispatch, getState) => {
		// const { offsetX, offsetY } = event.nativeEvent;
		const { offsetWidth, offsetHeight } = event.nativeEvent.target;
		const offsetY = event.nativeEvent.pageY;
		const { windowSize } = getState().base;
		
		// Initialize single doc chat config if opening without any pre-loaded config
		const { activeConfigs } = getState().chat;
		if (!activeConfigs["single"]) {
			dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_MEDIA}));
		}

		// This starts the spinner
		dispatch({ type: "sizeContentModal", offsetY, offsetWidth, offsetHeight, windowSize });
		dispatch(fetchMediaData(article));

		// delay so that the modal position is set first
		setTimeout(() => {
			dispatch({ type: "openContentModal" });
		}, 10);
	};
};

export function viewSocialMediaArticle(article, event) {
	return (dispatch, getState) => {
		try {
			// const { offsetX, offsetY } = event.nativeEvent;
			const { offsetWidth, offsetHeight } = event.nativeEvent.target;
			const offsetY = event.nativeEvent.pageY;
			const { windowSize } = getState().base;

			// Initialize single doc chat config if opening without any pre-loaded config
			const { activeConfigs } = getState().chat;
			if (!activeConfigs["single"]) {
				dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_SOCIAL_MEDIA}));
			}

			// This starts the spinner
			dispatch({ type: "sizeContentModal", offsetY, offsetWidth, offsetHeight, windowSize });
			dispatch(fetchSocialMediaData(article));

			// delay so that the modal position is set first
			setTimeout(() => {
				dispatch({ type: "openContentModal" });
			}, 10);
		} catch (err) {
			// console.log("ViewSocialMediaArticle - ", err);
		}
	};
};

// --------- Modals --------
export const closeAddSearchToGraphModal = () => {
	return {
		type: CLOSE_ADD_SEARCH_TO_GRAPH_MODAL,
	};
};

export const openAddSearchToGraphModal = () => {
	return {
		type: OPEN_ADD_SEARCH_TO_GRAPH_MODAL,
	};
};

export const selectSearchToAddToGraph = (params) => {
	return {
		type: SELECT_SEARCH_TO_ADD_TO_GRAPH,
		search: params,
	};
};

export const addSearchesToGraph = () => {
	return (dispatch, getState) => {
		const { lines } = getState().media;
		const {	comparableSearches } = getState().media;

		dispatch({ type: MEDIA_GRAPH_SPINNER_ON });

		_.each(comparableSearches, (search, index) => {
			const searchInGraph = _.find(lines, (lineInGraph) => {
				return lineInGraph.id === search.id;
			});
			setTimeout(
				() => {
					if (search.active && !searchInGraph) {
						dispatch(fetchMediaTimeseriesToCompare(search));
					} else if (!search.active && searchInGraph) {
						dispatch({ type: REMOVE_MEDIA_TIMESERIES, search });
					}
				},
				index ? 50 : 0
			);
		});
		dispatch({ type: CLOSE_ADD_SEARCH_TO_GRAPH_MODAL });
	};
};

export const removeSearchFromGraph = (search) => {
	return {
		type: REMOVE_SEARCH_FROM_GRAPH,
		search,
	};
};

// ------ Content toggles --------
export const toggleTranslate = () => {
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			contentFilteredByDate,
			showTranslate,
			articlesPageOffset,
		} = getState().media;
		const {	
			activeSearchObj,
			currentZoom,
		} = getState().search[stateId];

		const beginDate = contentFilteredByDate ? contentFilteredByDate.begin : currentZoom.begin;
		const endDate = contentFilteredByDate
			? contentFilteredByDate.end
				? Number(contentFilteredByDate.end)
				: moment(Number(contentFilteredByDate.begin)).add(1, "days").format("x")
			: currentZoom.end;

		dispatch({ type: SET_MEDIA_TRANSLATE_TOGGLE, showTranslate: !showTranslate });
		dispatch(
			fetchMediaArticles({
				begin: Number(beginDate),
				end: Number(endDate),
				query: activeSearchObj && activeSearchObj.query,
				showTranslate: !showTranslate,
				searchObj: activeSearchObj,
				sortBy: articlesSortType,
				ascending: articlesSortAscending,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: articlesPageOffset,
			})
		);
	};
};

export const updateTranslatableComponents = () => {
	return (dispatch, getState) => {
		const {
			articlesSortType,
			articlesSortAscending,
			showTranslate,
		} = getState().media;
		const {
			activeSearchObj,
			currentZoom,
			currentEntityType,
		} = getState().search[stateId];

		dispatch({ type: RESET_MEDIA_ARTICLES_CURSOR_POS });
		dispatch(
			fetchMediaArticles({
				ascending: articlesSortAscending,
				begin: currentZoom.begin,
				end: currentZoom.end,
				query: activeSearchObj && activeSearchObj.query,
				searchObj: activeSearchObj,
				showTranslate,
				sortBy: articlesSortType,
				pageLength: CONTENT_PAGE_LENGTH,
				offset: 0,
			})
		);
		// Update entities
		dispatch(updateMediaEntities());
	};
}

export const setArticlesExpanded = (expanded) => {
	return { type: SET_MEDIA_ARTICLES_EXPANDED, expanded };
};

export const setMediaArticlesCursorPosition = (params) => {
	return { type: SET_MEDIA_ARTICLES_CURSOR_POS, ...params };
};

export const setEntitiesExpanded = (expanded) => {
	return { type: SET_MEDIA_ENTITIES_EXPANDED, expanded };
};

export const setMapExpanded = (expanded) => {
	return { type: SET_MEDIA_MAP_EXPANDED, expanded };
};

export const setTimeSeriesExpanded = (expanded) => {
	return { type: SET_MEDIA_TIMESERIES_EXPANDED, expanded };
};

export const setTimeSeriesShrunk = (shrunk) => {
	return { type: SET_MEDIA_TIMESERIES_SHRUNK, shrunk };
};

export const clickMapCountry = (countryData) => {
	return (dispatch, getState) => {
		const { filters } = getState().search[stateId];
		const { allSourceCountryFilters } = getState().media;

		if (countryData?.name) {
			// Add all valid source country filters
			const updatedFilters = JSON.parse(JSON.stringify(filters));
			const sourceCountryFilter = findFilterByFieldName(updatedFilters, "sourceCountry.keyword");
			sourceCountryFilter.children = allSourceCountryFilters;

			// Build new source country filter
			const filterObject = convertCountryDataToEntityFilter({ 
				countryData, 
				filters: updatedFilters,
			});

			// Update filters
			dispatch({
				type: SEARCH_UPDATE_FILTERS,
				stateId,
				filters: addOrRemoveDynamicHierarchyFilter(filters, filterObject)
			});

			// Update results
			dispatch(updateMediaResults());
		}
	};
}